import React from "react";
import "./OurMission.css";

function OurMission() {
  return (
    <div className="mission">
      <div className="ourmission">
        <div className="missionheading">OUR MISSION</div>
        <div className="missioncontent">
          <div className="missionm1">
            To create a platform that encourages individuals to lead <span className="missionm11">active,
            healthy lifestyles</span> while also making a <span className="missionm11">positive impact</span>  on the world.
          </div>
          <div className="missionm2">
            <div className="missionm21">
                By connecting every step users take to charitable causes, and to
                discounts and giveaways from top global brands, we aim to inspire
                our community to get moving, feel good, and make a difference.
            </div>
          </div>  
        </div>
      </div>
    </div>
  );
}

export default OurMission;
